import { H4 } from '@monthio/design-system'
import { RegularButtonWrapper } from '@monthio/react-components'
import styled from 'styled-components'

export const EskatDummyTextStyle = styled(H4)`
	text-align: center;
`

export const StyledRegularButtonWrapper = styled(RegularButtonWrapper)`
	> button {
		width: 100%;
	}
	max-width: 358px;
	margin: auto;
`
